// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VEFSCalculator-vefsCalculator--xUmx{container-type:inline-size;font-size:.8rem;margin-block:1rem}.VEFSCalculator-numbers-3Yjph{grid-gap:.75rem .5rem;display:grid;gap:.75rem .5rem;margin-block:1rem}@container (width > 576px){.VEFSCalculator-numbers-3Yjph{grid-template-columns:repeat(3,1fr)}}.VEFSCalculator-headCol-3Kpk7{-ms-flex-item-align:end;align-self:end;padding:.5rem 0}.VEFSCalculator-numberDisplay-1c9sy>*{display:block;line-height:1.5;padding:.375rem .5rem}.VEFSCalculator-numberDisplay-1c9sy>:first-child{padding-bottom:.25rem}.VEFSCalculator-numberDisplay-1c9sy :last-child{background:#dee4ea;font-family:LabGrotesque-Medium,sans-serif}.VEFSCalculator-collapsible-1O0-D p{margin-block:1rem 2rem}.VEFSCalculator-collapsible-1O0-D p:last-child{margin-bottom:0}", ""]);
// Exports
exports.locals = {
	"orange": "#ea8f12",
	"red": "#b12f26",
	"darkBlue": "#33414e",
	"steel": "#62717f",
	"lightBlue": "#eff2f5",
	"cream": "#fbfaf8",
	"vefsCalculator": "VEFSCalculator-vefsCalculator--xUmx",
	"numbers": "VEFSCalculator-numbers-3Yjph",
	"headCol": "VEFSCalculator-headCol-3Kpk7",
	"numberDisplay": "VEFSCalculator-numberDisplay-1c9sy",
	"collapsible": "VEFSCalculator-collapsible-1O0-D"
};
module.exports = exports;
